import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c659705a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "arrow-block"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "arrow-separator"
}, null, -1));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
import { compile } from 'path-to-regexp';
import { reactive, toRefs, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ArrowRight } from '@element-plus/icons-vue';
import { useUserStore } from '@/stores/user';
export default {
  __name: 'index',
  setup(__props) {
    const user = useUserStore();
    const {
      headerFlag
    } = toRefs(user);
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      list: []
    });
    watchEffect(() => {
      let matched = route.meta.breadcrumbs ? route.meta.breadcrumbs.map(b => ({
        ...b,
        meta: {
          title: b.title
        }
      })) : route.matched.filter(item => item.meta && item.meta.title);
      if (headerFlag.value) {
        matched = [{
          path: '/',
          meta: {
            title: '首页'
          }
        }].concat(matched);
      }
      state.list = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
    });
    function pathCompile(path) {
      const {
        params
      } = route;
      const toPath = compile(path);
      return toPath(params);
    }
    function handleBack() {
      const breadcrumbs = route.meta.breadcrumbs ? route.meta.breadcrumbs.slice(0, -1) : [];
      const matched = breadcrumbs.length ? breadcrumbs.slice(-1) : [];
      if (matched.length) {
        const [r] = matched;
        const {
          query
        } = route;
        router.push({
          path: pathCompile(r.path),
          query: !headerFlag.value ? {
            header: 'hidden'
          } : query
        });
        return;
      }
      router.push('/home');
    }
    function handleLink(item) {
      const {
        query
      } = route;
      const {
        redirect,
        path
      } = item;
      if (redirect) {
        router.push(redirect);
        return;
      }
      router.push({
        path: pathCompile(path),
        query: !headerFlag.value ? {
          header: 'hidden'
        } : query
      });
    }
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        "separator-icon": _unref(ArrowRight)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.list, (l, index) => {
          return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: l.path
          }, {
            default: _withCtx(() => {
              var _l$meta, _l$meta2, _l$meta3;
              return [index === state.list.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString((_l$meta = l.meta) === null || _l$meta === void 0 ? void 0 : _l$meta.title), 1)) : index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createVNode(_component_Icon, {
                name: "el-icon-ArrowLeft",
                size: "14px"
              }), _createElementVNode("span", {
                onClick: $event => handleBack(l)
              }, "返回", 8, _hoisted_3), _hoisted_4, _createElementVNode("span", {
                onClick: $event => handleLink(l)
              }, _toDisplayString((_l$meta2 = l.meta) === null || _l$meta2 === void 0 ? void 0 : _l$meta2.title), 9, _hoisted_5)])) : (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: _withModifiers($event => handleLink(l), ["prevent"])
              }, _toDisplayString((_l$meta3 = l.meta) === null || _l$meta3 === void 0 ? void 0 : _l$meta3.title), 9, _hoisted_6))];
            }),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["separator-icon"]);
    };
  }
};